import styled, { css } from 'styled-components';

export const Background = styled.path<{ $active: boolean }>`
    opacity: 0;
    transition: all 200ms ease-out;

    &:hover {
        opacity: 1;
        transition: all 200ms ease-out;
    }

    ${({ $active }) =>
        $active &&
        css`
            opacity: 1;
            transition: all 200ms ease-out;
        `};
`;

export const Shape = styled.path``;

export const SVGContainer = styled.svg<{ $disabled: boolean }>`
    ${({ $disabled }) =>
        $disabled &&
        css`
            &:hover {
                ${Background} {
                    opacity: 0;
                }
            }

            ${Shape} {
                opacity: 0.5;
            }
        `}
`;
